module.exports = require('./helpers/bundle-url').getBundleURL('isz6D') + "logo-dark.eefe0b7f.svg";